import { ErrorBoundary } from "@/components/ErrorBoundary";
import { RouteLoadingFallback } from "@/components/LoadingSpinner";
import { Suspense } from "react";
import { View } from "react-native";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

// Import pages
import HomePage from "./pages/index";
import LoginPage from "./pages/login/index";
import PatientsPage from "./pages/patients/index";
import ProposalPage from "./pages/proposal";
import SessionPage from "./pages/session";

/**
 * App Content Container
 *
 * Wraps the routing content and provides:
 * - Full screen container (100% width/height)
 * - Routes for navigation
 * - Global toast notifications
 */
function AppContent() {
	return (
		<View id={"app-wrapper"} style={{ width: "100%", height: "100%" }}>
			<ErrorBoundary>
				<Suspense fallback={<RouteLoadingFallback />}>
					<Routes>
						<Route path="/" element={<HomePage />} />
						<Route path="/login/*" element={<LoginPage />} />
						<Route path="/patients" element={<PatientsPage />} />
						<Route path="/session" element={<SessionPage />} />
						<Route path="/proposal" element={<ProposalPage />} />
					</Routes>
				</Suspense>
			</ErrorBoundary>

			{/* Global toast notifications */}
			<Toaster />
		</View>
	);
}

/**
 * Root App Component
 */
function App() {
	return <AppContent />;
}

export default App;
